import { render, staticRenderFns } from "./PassPurposeInput.vue?vue&type=template&id=2293f1dc"
import script from "./PassPurposeInput.vue?vue&type=script&lang=js"
export * from "./PassPurposeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports